import { render, staticRenderFns } from "./DialogItemFooter.vue?vue&type=template&id=19d57f86&"
import script from "./DialogItemFooter.vue?vue&type=script&lang=js&"
export * from "./DialogItemFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports